
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import TestCallSection from "./TestCallSection";

export function TwilioConfigTab() {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <Alert>
        <InfoIcon className="h-4 w-4" />
        <AlertDescription>
          Twilio configuration has moved to the Integrations page. Please configure your Twilio credentials there.
        </AlertDescription>
      </Alert>
      <Button 
        variant="outline"
        onClick={() => navigate('/integrations?tab=twilio')}
        className="mb-6"
      >
        Go to Twilio Configuration
      </Button>

      <TestCallSection />
    </div>
  );
}
